import React from 'react';
import { Arrow, Group } from 'react-konva';
import { eventsColors } from '../../charts/colors';
import { PATH_WIDTH } from '../../track/ground/constants';
import { pathType } from './Path';
import Marker from './Marker';
import { canonicalToCanvas, ProcessedPlayer, Viewport } from '../lib';

type pePathType = number[][];
type PropsPowerEventsPath = {
  cursor: number
  pathData?: ProcessedPlayer;
  pePathData: pePathType;
  vp: Viewport;
};

const PowerEventsPath = React.memo(( props: PropsPowerEventsPath ) => {
  const {
    cursor,
    pathData,
    pePathData,
    vp,
  } = props;

  const pePaths: { intensity: number; path: number[] }[] = [];
  const markerPath: pathType = [];

  if (vp) {
    pePathData?.forEach(( pePoint ) => {
      const start = Math.trunc(pePoint[0]);
      const end = Math.trunc(pePoint[1]);
      const intensity = pePoint[2];
      const path: number[] = [];

      pathData?.samples.forEach(( point ) => {
        if (point.t >= start && point.t <= end) {
          const canvasPoint = canonicalToCanvas(point, vp);
          path.push(canvasPoint.cx);
          path.push(canvasPoint.cy);
          markerPath.push({
            timestamp: point.t,
            x: point.x,
            y: point.y,
          });
        }
      });
      pePaths.push({intensity, path});
    });
  }


  return (
    <>
      {pePaths.map(( path, idx ) => (
        // eslint-disable-next-line react/no-array-index-key
        <Group key={`arrow-${idx}`}>
          <Arrow
            points={path.path}
            stroke={eventsColors[2]}
            fill={eventsColors[2]}
            strokeWidth={PATH_WIDTH}
          />
        </Group>
      ))}
      <Marker
        pathData={{
          samples: markerPath
        }}
        cursor={cursor}
        vp={vp}
      />
    </>
  );
});

export default PowerEventsPath;
